module.exports = __webpack_public_path__ + "img/analytics-bottom-right-arrow.2149d207.png";